/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EntityWithHistoryType = {
    Unit: 'Unit',
    Enumeration: 'Enumeration',
    Quantity: 'Quantity',
    Comment: 'Comment',
    Role: 'Role',
    EnumerationOption: 'EnumerationOption',
    EnumerationQuantity: 'EnumerationQuantity',
    RtSystemQuantityScope: 'RtSystemQuantityScope',
    User: 'User',
    GeometryLabel: 'GeometryLabel',
    Protocol: 'Protocol',
    QaEquipment: 'QaEquipment',
    MedicalSystem: 'MedicalSystem',
    ManualTask: 'ManualTask',
    TaskItem: 'TaskItem',
    Text: 'Text',
    JobConfiguration: 'JobConfiguration',
    JobOccurrence: 'JobOccurrence',
    WorkStep: 'WorkStep',
    WorkItem: 'WorkItem'
} as const;
export type EntityWithHistoryType = typeof EntityWithHistoryType[keyof typeof EntityWithHistoryType];


export function EntityWithHistoryTypeFromJSON(json: any): EntityWithHistoryType {
    return EntityWithHistoryTypeFromJSONTyped(json, false);
}

export function EntityWithHistoryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityWithHistoryType {
    return json as EntityWithHistoryType;
}

export function EntityWithHistoryTypeToJSON(value?: EntityWithHistoryType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EntityWithHistoryType interface.
 */
 export function instanceOfEntityWithHistoryType(value: any): value is EntityWithHistoryType {
    return Object.values(EntityWithHistoryType).includes(value)
}

